import React from 'react';
import { Button } from './ui/button';

const HeroSection = ({ onGetInTouchClick }) => {
  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="https://images.unsplash.com/photo-1724906019868-93ad2c79414f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWNobm9sb2d5JTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3NTg0MTA4NTJ8MA&ixlib=rb-4.1.0&q=85"
          alt="Modern office collaboration and technology workspace - LOVEYUHLIFE digital innovation services"
          className="hero-image"
          loading="eager"
          width="1920"
          height="1080"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container px-8">
        <div className="hero-content text-center w-full flex flex-col" style={{ minHeight: 'calc(100vh - 160px)', justifyContent: 'space-between' }}>
          <div className="pt-4">
            <h1 className="brand-display mb-6 w-full">
              Elevating Small Business Through Digital Innovation
            </h1>
            
            <p className="body-large mb-12 w-full px-4" style={{ color: '#000000' }}>
              We're an emerging web development company specializing in comprehensive digital solutions for small businesses. From stunning logo design to robust project management systems.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center pb-8">
            <Button 
              onClick={onGetInTouchClick}
              className="btn-primary btn-hover-scale"
            >
              Start Your Project
            </Button>
            
            <Button 
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="btn-secondary btn-hover-scale"
            >
              View Our Services
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;